module.exports = __webpack_public_path__ + "img/bity.030b8c50.png";